import { createActions } from 'redux-actions';
import { request, create, update } from '../../services';
import { getWorkroomFilters } from '../../reducers';
import Schemas from 'schemas';
import { normalize } from 'normalizr';
import qs from 'qs';

const {
  workroomListRequest,
  workroomListSuccess,
  workroomListFailure,
} = createActions(
  'WORKROOM_LIST_SUCCESS', 'WORKROOM_LIST_REQUEST', 'WORKROOM_LIST_FAILURE');

export function requestWorkroomList() {
  return (dispatch, getState) => {
    const state = getState();
    const filterParams = qs.stringify(getWorkroomFilters(state));
    dispatch(workroomListRequest());
    return request(`workrooms?${filterParams}`)
      .then(({ json }) => {
        dispatch(workroomListSuccess(json));
      },
      (error) => {
        dispatch(workroomListFailure(error));
      });
  };
}

const {
  workroomResourceRequest,
  workroomResourceSuccess,
  workroomResourceFailure,
} = createActions({
  WORKROOM_RESOURCE_REQUEST: id => ({ id }),
  WORKROOM_RESOURCE_SUCCESS: json => normalize(json, Schemas.WORKROOM),
}, 'WORKROOM_RESOURCE_FAILURE');

export function requestWorkroom(id) {
  return (dispatch) => {
    dispatch(workroomResourceRequest(id));
    request(`workrooms/${id}`)
      .then(({ json }) => dispatch(workroomResourceSuccess(json)))
      .catch(error => dispatch(workroomResourceFailure(error)));
  };
}

const {
  workroomResourceCreateRequest,
  workroomResourceCreateSuccess,
  workroomResourceCreateFailure,
} = createActions({
  WORKROOM_RESOURCE_CREATE_SUCCESS: json => normalize(json, Schemas.WORKROOM),
}, 'WORKROOM_RESOURCE_CREATE_REQUEST', 'WORKROOM_RESOURCE_CREATE_FAILURE');

export function createWorkroom(workroom) {
  return (dispatch) => {
    dispatch(workroomResourceCreateRequest());
    return create('workroom', workroom)
    .then(({ json }) => dispatch(workroomResourceCreateSuccess(json)))
    .catch(error => dispatch(workroomResourceCreateFailure(error)));
  };
}

const {
  workroomResourceUpdateRequest,
  workroomResourceUpdateSuccess,
  workroomResourceUpdateFailure,
} = createActions({
  WORKROOM_RESOURCE_UPDATE_SUCCESS: json => normalize(json, Schemas.WORKROOM),
}, 'WORKROOM_RESOURCE_UPDATE_REQUEST', 'WORKROOM_RESOURCE_UPDATE_FAILURE');

export function updateWorkroom(workroom) {
  return (dispatch) => {
    dispatch(workroomResourceUpdateRequest());
    return update('workroom', workroom)
      .then(({ json }) => dispatch(workroomResourceUpdateSuccess(json))
      , error => dispatch(workroomResourceUpdateFailure(error)),
      );
  };
}

export function setWorkroomFilters(filter) {
  return (dispatch) => {
    dispatch({ type: 'WORKROOM_SET_FILTER', payload: filter });
    dispatch(requestWorkroomList());
  };
}

export function resetWorkroomFilters() {
  return (dispatch) => {
    dispatch({ type: 'WORKROOM_RESET_FILTERS' });
    dispatch(requestWorkroomList());
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/workrooms.js